export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GegevensWijzigen.vue?vue&type=template&id=2f31deef&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MijnAccount/GegevensWijzigen.vue?vue&type=template&id=2f31deef&
// module id = 429
// module chunks = 0